export enum CareIsFor {
  Self = 'self',
  Child = 'child',
}

export const CareForStorageKey = 'careIsFor';
